import React from 'react';
export const Doc = (props) => {
    return <>{props.children}</>;
};